import { AsyncStoreItem } from '@lib/store';
import { EncryptYamatoBaggageResponse } from 'src/sdk-servicing';

/**
 * EncryptYamatoBaggageResult model
 */
export interface EncryptYamatoBaggageResultModel {
  model: EncryptYamatoBaggageResponse | null;
}

/**
 * EncryptYamatoBaggageResponse model details
 */
export interface EncryptYamatoBaggageResultStateDetails extends AsyncStoreItem {}

/**
 * EncryptYamatoBaggageResult store state
 */
export interface EncryptYamatoBaggageResultState
  extends EncryptYamatoBaggageResultStateDetails,
    EncryptYamatoBaggageResultModel {}

/**
 * Name of the EncryptYamatoBaggageResult Store
 */
export const ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME = 'encryptYamatoBaggageResult';

/**
 * EncryptYamatoBaggageResult Store Interface
 */
export interface EncryptYamatoBaggageResultStore {
  /** EncryptYamatoBaggageResult state */
  [ENCRYPT_YAMATO_BAGGAGE_RESULT_STORE_NAME]: EncryptYamatoBaggageResultState;
}
